'use client';

import { ExperimentProvider as CarvanaExperimentProvider } from '@carvana/experiment';
import React from 'react';
import { settings } from '~/constants/common/experiments';
import { type PropsFromServer } from '~/context/common/ExperimentProvider';

type OwnProps = React.PropsWithChildren<
  Pick<PropsFromServer, 'experiments' | 'serverCookies'>
>;

export default function SrpExperimentProvider(props: OwnProps) {
  return (
    <CarvanaExperimentProvider
      defaults={settings}
      preloadedExperiments={props.experiments}
      serverCookies={props.serverCookies}
    >
      {props.children}
    </CarvanaExperimentProvider>
  );
}

type ConditionalProps = React.PropsWithChildren<{
  experimentContext?: PropsFromServer;
}>;

// To support using SearchProviders in both routers, we conditionally render
// ExperimentProvider based on the presence of experimentContext
// props which is still provided by pages router getProps
export function ConditionalSrpExperimentProvider({
  children,
  experimentContext
}: ConditionalProps) {
  return experimentContext ? (
    <SrpExperimentProvider {...experimentContext}>
      {children}
    </SrpExperimentProvider>
  ) : (
    <>{children}</>
  );
}
